import React, { useContext, useMemo, useRef } from 'react';
import { Switch, Route } from 'react-router-dom';
import { NexusProvider } from '@return-rabbit/nexus';
import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import aphroditeInterface from 'react-with-styles-interface-aphrodite';
import _get from 'lodash/get';
import 'react-dates/initialize';
import '@coreui/icons/css/coreui-icons.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './scss/style.css';

import { logError } from 'utils';
import {
  LoginRoute,
  LogoutRoute,
  ProtectedRoute,
  UnProtectedRoute,
  OnboardingRoute,
  ForcePasswordChangeRoute
} from './utils/routes';
import {
  ConnectLayout,
  DefaultLayout,
  LoginLayout,
  EmptyLayout,
  ShipStationConnect
} from 'containers';
import { ErrorBoundary } from 'components';
import NotSupportedBrowser from './NotSupportedBrowser';
import ForceChangePassword from 'views/ForceChangePassword';
import { isSSRTheme } from 'utils';
import { useNexusConfg } from 'utils/hooks';
import { AuthContext } from 'context/AuthContext';
// import subscribeToPusher from './config/setup/__DEPRECATED__subscribeToPusher';

ThemedStyleSheet.registerInterface(aphroditeInterface);

export default function App() {
  const { axiosConfig, masterData, storeProperties } = useNexusConfg();
  const { userData } = useContext(AuthContext);

  const isNotSupported = useRef(
    navigator.appName === 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      )
  ).current;

  const userInfo = useMemo(() => {
    if (!userData) return null;

    return {
      id: _get(userData, 'userId'),
      email: _get(userData, 'email'),
      firstName: _get(userData, 'firstName'),
      lastName: _get(userData, 'lastName')
    };
  }, [userData]);

  if (isNotSupported) {
    return <NotSupportedBrowser />;
  }

  const isSSRMode = isSSRTheme();

  const routes = isSSRMode
    ? []
    : [
        <LoginRoute key="login" exact path="/login" component={LoginLayout} />,
        <Route
          key="ss-connect"
          path="/ss-connect"
          component={ShipStationConnect}
        />,
        <UnProtectedRoute
          key="connect-store"
          path="/connect-store"
          component={ConnectLayout}
        />,
        <UnProtectedRoute
          key="reset-password"
          path="/reset-password"
          component={LoginLayout}
        />,
        <OnboardingRoute
          key="onboarding"
          path="/onboarding"
          component={EmptyLayout}
        />,
        <ForcePasswordChangeRoute
          key="force-password-change"
          path="/password-change"
          component={ForceChangePassword}
        />
      ];

  return (
    <ErrorBoundary>
      <NexusProvider
        mode="RR-ADMIN"
        axiosConfig={axiosConfig}
        masterData={masterData}
        storeProperties={storeProperties}
        logErrror={logError}
        userInfo={userInfo}
        // segmentApiKey={process.env.REACT_APP_SEGMENT_API_KEY}
      >
        <Switch>
          <LogoutRoute path="/logout" />
          {routes}
          <ProtectedRoute
            isSSRMode={isSSRMode}
            path="/"
            component={DefaultLayout}
          />
        </Switch>
      </NexusProvider>
    </ErrorBoundary>
  );
}
